import { render } from "./template.vue?vue&type=template&id=478ee397&scoped=true"
const script = {}

import "./template.vue?vue&type=style&index=0&id=478ee397&lang=scss&scoped=true"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-478ee397"]])

export default __exports__